import { defineMessages } from 'react-intl.macro';
import description from './assets/description.json';

export default defineMessages({
  heading: {
    id: 'views.CorporateGovernance.heading',
    defaultMessage: 'Ład korporacyjny'
  },
  greyBoxHeader: {
    id: 'views.CorporateGovernance.greyBox.header',
    defaultMessage: description.heading
  },
  articleHeader: {
    id: 'views.UnionProjects.article.header',
    defaultMessage:
      'Najważniejsze dokumenty wewnętrzne regulujące zasady ładu korporacyjnego w grupie Tenderhut:'
  },
  documentTitle1: {
    id: 'views.UnionProjects.document.title1',
    defaultMessage: 'Statut spółki TenderHut SA'
  },
  documentTitle2: {
    id: 'views.UnionProjects.document.title2',
    defaultMessage: 'Regulamin zarządu'
  },
  documentTitle3: {
    id: 'views.UnionProjects.document.title3',
    defaultMessage: 'Regulamin Rady Nadzorczej'
  },
  documentTitle4: {
    id: 'views.UnionProjects.document.title4',
    defaultMessage: 'Regulamin Walnego Zgromadzenia'
  }
});



// WEBPACK FOOTER //
// ./src/views/CorporateGovernance/CorporateGovernanceView.intl.js